import { s } from '../../detail/components/summary/Summary.styles';
import styled from 'styled-components';
import { DetailDataProps } from '../data';
import { copyUrl } from '../../../utils/url';

interface Props {
  caseInfo: DetailDataProps;
}

function Summary({ caseInfo }: Props) {
  const handleCopyAddress = () => {
    navigator.clipboard
      .writeText(caseInfo?.addr ? caseInfo.addr : '')
      .then(() => {
        alert('주소가 복사되었습니다!');
      })
      .catch((err) => {
        console.error('주소 복사에 실패했습니다:', err);
        alert('주소 복사에 실패했습니다.');
      });
  };

  return (
    <s.Container id="요약정보">
      <s.SummaryBox>
        <s.Block flexDir="column">
          <s.ItemTypeChip
            style={{
              backgroundColor: '#FFF1DB',
              color: '#FF7300',
            }}
          >
            예정
          </s.ItemTypeChip>
          <s.AddressBox>
            <s.JiBunAddressBox>
              <s.JibunAddress>{caseInfo.addr}</s.JibunAddress>
              <s.CopyButton onClick={handleCopyAddress}>
                <img src="/assets/images/icon/copy-blue.svg" alt="" />
                <span>복사</span>
              </s.CopyButton>
            </s.JiBunAddressBox>
          </s.AddressBox>
        </s.Block>
        <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
          {[
            {
              title: '네이버지도',
              link: `https://map.naver.com/p/search/${caseInfo ? caseInfo.addr : ''}`,
            },
            {
              title: '카카오지도',
              link: `https://map.kakao.com/?q=${caseInfo ? caseInfo.addr : ''}`,
            },
            {
              title: '씨:리얼지도',
              link: `https://seereal.lh.or.kr/SeerealMAP/seerealCommon/mainPage.do?redirect=true&center=null&zoom=null&layer=null&address=null&gMenu=null&pnu=${caseInfo && caseInfo.pnu}`,
            },
          ].map((el) => {
            return (
              <MapButton onClick={() => window.open(el.link)}>
                {el.title}
              </MapButton>
            );
          })}
        </div>
        <s.Block flexDir="row">
          <s.BidInfoItem>
            <span>사건접수</span>
            <s.BidInfoContent>
              {caseInfo.reg_date ? caseInfo.reg_date.split('T')[0] : '-'}
            </s.BidInfoContent>
          </s.BidInfoItem>
          <s.Divider></s.Divider>
          <s.BidInfoItem>
            <span>배당요구종기일</span>
            <s.BidInfoContent>
              {caseInfo.div_date ? caseInfo.div_date.split('T')[0] : '-'}
            </s.BidInfoContent>
          </s.BidInfoItem>
          <s.Divider></s.Divider>
          <s.BidInfoItem>
            <span>경매개시일</span>
            <s.BidInfoContent>
              {caseInfo.dec_date ? caseInfo.dec_date.split('T')[0] : '-'}
            </s.BidInfoContent>
          </s.BidInfoItem>
        </s.Block>
      </s.SummaryBox>
      <s.InterestButtonBox>
        <s.InterestButton onClick={() => copyUrl()}>
          <img src="/assets/images/icon/upload-gray.svg" alt="" />
          <span>공유</span>
        </s.InterestButton>
        <s.Divider> </s.Divider>
        <s.InterestButton style={{ opacity: 0.2 }}>
          <img src={`/assets/images/icon/lined-star.svg`} alt="" />
          <span>관심</span>
        </s.InterestButton>
      </s.InterestButtonBox>
    </s.Container>
  );
}

export default Summary;

const MapButton = styled.button`
  width: 84px;
  height: 27px;
  padding: 5px 8px;
  border-radius: 8px;
  background: #f3f5f7;
  cursor: pointer;
  text-align: center;
  border: none;
`;
